import { render, staticRenderFns } from "./search.vue?vue&type=template&id=07d780da&scoped=true&"
import script from "./search.vue?vue&type=script&lang=ts&setup=true&"
export * from "./search.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./search.vue?vue&type=style&index=0&id=07d780da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d780da",
  null
  
)

export default component.exports